/**
 * Detects the "Nova subscription required" paywall signal.
 *
 * Nova's gate is thrown, not returned, so it travels the same channel as a real
 * failure. Two producers, one shape:
 * - `NovaAccessDeniedError` (`~/lib/server/nova/access`), thrown by server-fn
 *   enforcement points. Crossing the server-fn wire can strip the `code`
 *   property, leaving only the message.
 * - The client-side sentinel in `use-start-nova-conversation`, thrown from a
 *   warm subscription cache to skip a round-trip that would only be denied.
 *
 * Both are expected control flow — the caller navigates the coach to the
 * paywall room — so this predicate is what keeps them out of Sentry (see
 * `sentry-mutation-reporter`), alongside `isAuthError`.
 *
 * Pure utility — safe to import from server or client code.
 */
export function isNovaSubscriptionRequiredError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return (
    (error as { code?: unknown }).code === "subscription_required" ||
    error.message === "Nova subscription required"
  );
}
